
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleContactClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('contact');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      scrollToSection('contact');
    }
  };

  const handleAboutClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('about');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      scrollToSection('about');
    }
  };

  const handleServicesClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('services');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      scrollToSection('services');
    }
  };

  const handleJoKreativClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('jo-kreativ');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      scrollToSection('jo-kreativ');
    }
  };

  const handleVereinClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('verein-ferienhaus');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      scrollToSection('verein-ferienhaus');
    }
  };

  const handleWohnungenClick = () => {
    navigate('/wohnungsvermietung');
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={handleLogoClick}>
            <img 
              src="https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/611f2d4800fd70d3498a76a52e2b73dd.png" 
              alt="De Born's Logo" 
              className="h-12 w-auto"
            />
            <h1 className="text-2xl font-bold text-green-600" style={{ fontFamily: '"Pacifico", serif' }}>
              De Born's
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={handleAboutClick}
              className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
            >
              Über uns
            </button>
            <button
              onClick={handleServicesClick}
              className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
            >
              Unsere Leistungen
            </button>
            <button
              onClick={handleJoKreativClick}
              className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
            >
              Jo Kreativ Design
            </button>
            <button
              onClick={handleVereinClick}
              className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
            >
              Verein und Ferienhaus
            </button>
            <button
              onClick={handleWohnungenClick}
              className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
            >
              Unsere Wohnungen
            </button>
            <button
              onClick={handleContactClick}
              className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
            >
              Kontakt
            </button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-green-600 focus:outline-none cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <button
                onClick={handleAboutClick}
                className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors cursor-pointer w-full text-left"
              >
                Über uns
              </button>
              <button
                onClick={handleServicesClick}
                className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors cursor-pointer w-full text-left"
              >
                Unsere Leistungen
              </button>
              <button
                onClick={handleJoKreativClick}
                className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors cursor-pointer w-full text-left"
              >
                Jo Kreativ Design
              </button>
              <button
                onClick={handleVereinClick}
                className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors cursor-pointer w-full text-left"
              >
                Verein und Ferienhaus
              </button>
              <button
                onClick={handleWohnungenClick}
                className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors cursor-pointer w-full text-left"
              >
                Unsere Wohnungen
              </button>
              <button
                onClick={handleContactClick}
                className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors cursor-pointer w-full text-left"
              >
                Kontakt
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
